module.exports = __webpack_public_path__ + "img/luck_jinbi.ffc15ccb.png";